import client from "../modules/client";
import HelperService from "./helper-service";

export const getList = (filter={}) => {
  let query = HelperService.getFilterQueryString({
    from: filter.from || null,
  });
  return client(`/api/v1/inbox?${query}`).then(({ data }) => data);
};

export const reset = () => {
  return client(`/api/v0/inbox/reset`, {method:'POST', body:{}}).then(({ data }) => data);
};

export const clean = () => {
  return client(`/api/v0/inbox/clean`, {method:'POST', body:{}}).then(({ data }) => data);
};

export function useInboxService () {
  return {
    getList,
    reset,
    clean,
  };
}
